import { render, staticRenderFns } from "./FormWizardEdit.vue?vue&type=template&id=28e7a4c0&"
import script from "./FormWizardEdit.vue?vue&type=script&lang=js&"
export * from "./FormWizardEdit.vue?vue&type=script&lang=js&"
import style0 from "./FormWizardEdit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports